import { useState, useCallback, useMemo } from "react";

export function useSortable() {
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState(null);

  const handleSort = useCallback((column) => {
    if (sortKey === column) {
      if (sortDir === "asc") {
        setSortDir("desc");
      } else {
        setSortKey(null);
        setSortDir(null);
      }
    } else {
      setSortKey(column);
      setSortDir("asc");
    }
  }, [sortKey, sortDir]);

  const applySort = useCallback((data, sortConfig) => {
    if (!sortKey || !sortDir || !data) return data;
    const list = [...data];
    const config = sortConfig[sortKey];
    if (!config) return data;

    list.sort((a, b) => {
      const valA = config.getValue(a);
      const valB = config.getValue(b);
      if (valA < valB) return sortDir === "asc" ? -1 : 1;
      if (valA > valB) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
    return list;
  }, [sortKey, sortDir]);

  return { sortKey, sortDir, handleSort, applySort };
}